export enum CubeGroupTypes {
  RELATIVES = 'RELATIVES',
  TAX_BENEFITS = 'TAX_BENEFITS',
  TAX_BENEFITS_ADDITIONAL_INCOME = 'TAX_BENEFITS_ADDITIONAL_INCOME'
}
